import type { MadBuyLineItemGeneralForm } from '../../lineItemsModel';

export enum LineItemEditorTab {
  General = 'general',
  Schedule = 'schedule',
  Targeting = 'targeting',
  CustomTargeting = 'customTargeting',
  Creatives = 'creatives',
  Conversion = 'conversion',
}

export type LineItemFormUpdate = <TKey extends keyof MadBuyLineItemGeneralForm>(
  key: TKey,
  nextValue: MadBuyLineItemGeneralForm[TKey],
) => void;
